import React from "react";
import TabMenu from "./TabMenu";
import VillaStats from "./VillaStats";

const VillaHeader = ({ views, recentViews }) => {
  return (
    <div className="flex flex-col items-start gap-3 mb-3 bg-white lg:flex-row lg:gap-10 md:gap-5">
      <TabMenu />
      <div className="hidden py-1 lg:block">
        <VillaStats views={views} recentViews={recentViews} />
      </div>
    </div>
  );
};

export default VillaHeader;
